var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div"),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(_vm.soundList, function(song, index) {
        return _c(
          "ul",
          { key: index, staticClass: "ul-style", attrs: { id: index } },
          [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/Selectedsong" } }, [
                  _c("img", {
                    staticClass: "sound-title",
                    attrs: { src: song.titleImage },
                    on: {
                      click: function($event) {
                        return _vm.selectedSong(song.id, song.assignment_img)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.isPlaySong === false
                  ? _c("img", {
                      staticClass: "btn-size",
                      attrs: { src: song.playImage },
                      on: {
                        click: function($event) {
                          return _vm.playSound(song.sound, index)
                        }
                      }
                    })
                  : _c("img", {
                      staticClass: "btn-size",
                      attrs: { src: song.playImage },
                      on: {
                        click: function($event) {
                          return _vm.stopSound(index)
                        }
                      }
                    })
              ],
              1
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "selet-song-msg" }, [
      _c("img", { attrs: { src: require("@/assets/img/アセット 50@3x.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-560dbd96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560dbd96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Selectsong.vue
// module id = null
// module chunks = 